export default "__VITE_ASSET__y0fUuOg4__"